import { DetailedSubscription, Subscription } from "@/types/Subscription";
import type { DissolvePreflightKeys } from "@/components/PDeleteCompany/dissolveText";
import { apiGet } from "../_apiShim";

const BASE_PATH = "/api/v1/subscriptions/";

export async function getActiveSubscription(
  companyId: string,
): Promise<boolean> {
  const url = `${BASE_PATH}${companyId}/active`;

  return await apiGet<boolean>(
    url,
    {
      "Cache-Control": "no-store",
    },
    true,
  );
}

/**
 * PB-CDP: may this organisation be deleted, and what would it forfeit —
 * `{dissolveCheckFailed, dissolveBlock, dissolveLosses}` (OWNER only; the
 * backend's Mongo verdict, never fails: a failed read is
 * `dissolveCheckFailed: true`). An old backend has no such route (404), and
 * the danger zone then falls back to {@link getActiveSubscription}.
 */
export async function getDissolvePreflight(
  companyId: string,
): Promise<DissolvePreflightKeys> {
  return await apiGet<DissolvePreflightKeys>(
    `${BASE_PATH}${companyId}/dissolve-preflight`,
    {
      "Cache-Control": "no-store",
    },
    true,
  );
}

export async function getActivePaidSubscription(
  companyId: string,
): Promise<boolean> {
  const url = `${BASE_PATH}${companyId}/active-paid`;

  return await apiGet<boolean>(
    url,
    {
      "Cache-Control": "no-store",
    },
    true,
  );
}

export async function getSubscriptions(
  companyId: string,
  fields: string,
): Promise<Subscription[]> {
  const url = `${BASE_PATH}${companyId}?fields=${encodeURIComponent(fields)}`;

  return await apiGet<Subscription[]>(
    url,
    {
      "Cache-Control": "no-store",
    },
    true,
  );
}

export async function getDetailedSubscriptions(
  companyId: string,
  fields: string,
): Promise<DetailedSubscription[]> {
  const url = `${BASE_PATH}${companyId}/detailed?fields=${encodeURIComponent(fields)}`;

  return await apiGet<DetailedSubscription[]>(
    url,
    {
      "Cache-Control": "no-store",
    },
    true,
  );
}
